var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "featured-jobs__list"
  }, _vm._l((_vm.results), function(result) {
    return _c('Job', {
      key: result.id,
      staticClass: "featured-jobs__job",
      attrs: {
        "job": result,
        "show": {
          date: false,
          company: true,
          motto: false,
        }
      }
    })
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6ab08a6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/featured-jobs.vue
// module id = null
// module chunks = 